import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, StepLabel, StepContent } from '@mui/material'
import { FormTable, TableHeader, TableRow } from '@front/squirtle'

import HistoryHeader from './Header'
import HistoryRow from './Row'

const HistorySection = ({ record_id }) => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('voucher.history')}</Typography>
  </StepLabel>
  <StepContent>
    <Box sx={{ borderRadius: 3, boxShadow: 6, p: 2, mb: 1 }}>
      <FormTable
        model_name='order'
        config={{
          populate: [
            'voucher',
            'do.commercial_formula',
            'do.customerinfo',
            'do.info',
            'service.contract.company',
            'service.contract.formula',
          ],
          initial_filter: { voucher: record_id },
          forced_filter: {
            voucher: record_id,
            status: { '!': 'canceled' }
          },
          sort: ['requestedAt DESC']
        }}
        tableProps={{
          enablePagination: true,
          onRowClick: null,
        }}
      >
        <TableHeader><HistoryHeader /></TableHeader>
        <TableRow><HistoryRow /></TableRow>
      </FormTable>
    </Box>
  </StepContent>
</>

export default React.memo(HistorySection)
